
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import Step from '@/components/step.vue';
  import CollapseItem from '@/components/collapse.vue';
  import PageFooter from '@/components/page-footer.vue';
  import RefundChangeSku from './components/refund-change-sku.vue';
  import Message from '@/components/message.vue';
  import {
    getOrderAfterDetail,
    orderRefund
  } from '@/api/after_sales'
  import {
    afterStatus,
    afterSalesResults,
    afterSalesTypes
  } from '@/utils/config'

  @Component({
    name: 'after-sales-detail',
    components: {
      Step,
      CollapseItem,
      PageFooter,
      RefundChangeSku,
      'slz-message': Message
    }
  })
  export default class AfterSalesDetail extends Vue {
    private orderId = +this.$route.query.id || 0;
    private orderType = +this.$route.query.type || 0;
    private orderInfo: any = {}
    private addressInfo: any = {}
    private buyWords: string = ''
    private deliverPrice: number = 0;
    private afterStatusConfig = afterStatus;
    private showMessage = false;

    private selectIds: number[] = []
    // private stepList = ['申请中', '售后中', '已完成'];
    // private activeStep = 0;
    private afterType = '';
    private afterTypes: any = afterSalesTypes.slice(1);
    private afterReason = '';
    private afterReasons: any = afterSalesResults.slice(1);
    private isReturnGoods = 0;
    private returnGoodsType: any = [{
      label: '否',
      value: 0
    }, {
      label: '是',
      value: 1
    }]
    private formData: any = {
      zd_refund_money: 0,
      hx_refund_money: 0,
      lc_refund_money: 0
    }
    private selectProdutId = 0;
    private selectSkuId = 0;
    private selectIndex: any = null;
    private showDialog = false;
    private disabledStatus = [1, 2, 3, 4, 5, 7, 8]

    mounted() {
      // if (this.orderType) {
      //   this.afterTypes = [{
      //     label: '退货退款',
      //     value: 2
      //   }]
      // }
      this.getDetail();
    }

    private toBack() {
      this.$router.go(-1);
    }

    private changeSalesType() {
      this.getTotalRefundMoney()
    }

    private getTotalRefundMoney() {
      this.formData = {
        zd_refund_money: 0,
        hx_refund_money: 0,
        lc_refund_money: 0
      }
      this.orderInfo && this.orderInfo.map((item: any) => {
        if (this.disabledStatus.indexOf(item.order_status) !== -1 && item.refund_type === 2) {
          this.formData.refund_money += ((item.refund_product.refund_goods_price || 0) + item.refund_product
            .ext_price * 100)
        } else if (this.selectIds.indexOf(item.order_product_id) !== -1 && item.refund_type === 2) {
          let price = item.order_product.agent_price / item.order_product.num;
          let ext_price = +item.refund_product.ext_price * 100;
          this.formData.zd_refund_money += (parseInt( price * item.refund_product.num + '') + ext_price);
          this.formData.hx_refund_money += (parseInt((price - item.order_product.price_spread) * item.refund_product.num + '') + ext_price);
          this.formData.lc_refund_money += (parseInt((price - item.order_product.price_spread * 2) * item.refund_product.num + '') + ext_price);
        }
      })
      
    }

    private changeCheck(e: any, id: number, index) {
      let nindex: number = this.selectIds.indexOf(id);
      if (nindex === -1) {
        this.selectIds.push(id)
      } else {
        this.selectIds.splice(nindex, 1)
      }
      this.getTotalRefundMoney()
      let refs: any = this.$refs['collapse_' + index];
      if (refs) {
        refs[0].handleOpen();
      }
    }

    /**
     * @func 修改退货退款类型售后商品数量
     * @param obj (value: string|number)
     * @param index 当前操作的商品序号
     */
    private changeRefundProductNum(obj: any, index: number) {
      let data = this.orderInfo[index];
      if (+obj > data.order_product.num) {
        this.$message({
          type: 'warning',
          message: '售后商品数不能超过订单商品数'
        });
        data.refund_product.num = data.order_product.num;
        this.$set(this.orderInfo, index, data);
        return;
      }
      data.refund_product.refund_goods_price = +obj * (data.order_product.price / data.order_product.num);
      this.$set(this.orderInfo, index, data);
      this.getTotalRefundMoney()
    }

    /**
     * @func 显示选择sku弹窗
     * @param productId 当前商品id
     * @param skuId 当前选择的skuId
     * @param index current goods index
     */
    private showSkuDialog(productId: number, skuId: number, index) {
      if (this.disabledStatus.indexOf(this.orderInfo[index].order_status) !== -1) return;
      this.selectProdutId = +productId || 0;
      this.selectSkuId = +skuId || 0;
      this.selectIndex = index;
      this.showDialog = true;
    }

    /**
     * @func 选择sku回调
     * @param obj {sku_id: number, text: string}
     */
    private returnSku(obj: any) {
      let data = this.orderInfo[this.selectIndex];
      data.order_changes.sku_id = obj.sku_id;
      data.order_changes.params = obj.text;
      this.$set(this.orderInfo, this.selectIndex, data);
      this.selectIndex = null;
    }



    private async getDetail() {
      let refund_product: any = {
          is_refund: 0,
          num: 1,
          ext_price: '',
          logistics_code: '',
          logistics_id: '',
          refund_time: 0
        },
        order_replenish: any = {
          reissue_num: 1,
          logistics_code: '',
          logistics_id: '',
          refund_time: 0,
        },
        order_changes: any = {
          change_num: 1,
          product_id: 0,
          sku_id: '',
          params: '',
          logistics_code: '',
          logistics_id: '',
          refund_time: 0,
          send_logistics_code: '',
          send_logistics_id: '',
          send_logistics_time: 0
        }
      try {
        const res: any = await getOrderAfterDetail({
          order_id: this.orderId
        })
        this.addressInfo = res.address;
        this.buyWords = res.buyer_words;
        this.deliverPrice = res.delivery_price;
        this.orderInfo = res.info && res.info.map((item: any) => {
          !item.refund_product && (item.refund_product = JSON.parse(JSON.stringify(refund_product)));
          !item.order_replenish && (item.order_replenish = JSON.parse(JSON.stringify(order_replenish)));
          !item.order_changes && (item.order_changes = JSON.parse(JSON.stringify(order_changes)));
          if (!item.refund_type) {
            item.refund_type = 2;
            // item.refund_type = this.orderType ? 2 : 1;
            item.after_type = ''
          }
          if (item.refund_type === 2 && item.refund_product.ext_price) {
            item.refund_product.ext_price /= 100;
          }

          !item.order_status && (item.refund_product.num = item.order_product.num)
          item.refund_product.refund_goods_price = (item.order_product.price || 0);
          return item;
        });
        this.getTotalRefundMoney()
      } catch (e) {
        console.log(e)
      }
    }

    private transformObj(data: any) {
      let obj = JSON.parse(JSON.stringify(data))
      obj.order_replenish = {
        reissue_num: +obj.order_replenish.reissue_num,
        logistics_code: obj.order_replenish.logistics_code || '',
        logistics_id: +obj.order_replenish.logistics_id || 0,
        refund_time: +obj.order_replenish.refund_time
      }
      obj.refund_product = {
        is_refund: +obj.refund_product.is_refund,
        num: +obj.refund_product.num,
        ext_price: (+obj.refund_product.ext_price) * 100,
        logistics_code: obj.refund_product.logistics_code || '',
        logistics_id: +obj.refund_product.logistics_id || 0,
        refund_time: +obj.refund_product.refund_time,
        refund_goods_price: +obj.refund_product.refund_goods_price || 0
      }
      obj.order_changes = {
        change_num: +obj.order_changes.change_num,
        product_id: +obj.order_product.product_id || 0,
        sku_id: +obj.order_changes.sku_id || 0,
        params: obj.order_changes.params || '',
        logistics_code: obj.order_changes.logistics_code || '',
        logistics_id: +obj.order_changes.logistics_id || 0,
        refund_time: +obj.order_changes.refund_time || 0,
        send_logistics_code: obj.order_changes.send_logistics_code || '',
        send_logistics_id: +obj.order_changes.send_logistics_id,
        send_logistics_time: +obj.order_changes.send_logistics_time || 0,
      }
      return obj;
    }

    private async handleConfirm() {
      let list: any = [];
      let isEmpty: boolean = false;
      this.orderInfo.map((item: any) => {
        if (this.selectIds.indexOf(item.order_product_id) !== -1) {
          if (!item.after_type) {
            this.$message({
              type: 'warning',
              message: '请选择' + item.order_product.product_name + item.order_product.params + '退款原因'
            })
            isEmpty = true;
          }
          if (item.refund_type === 1 && (!item.order_replenish.reissue_num)) {
            this.$message({
              type: 'warning',
              message: item.order_product.product_name + item.order_product.params + '信息不完整'
            })
            isEmpty = true;
          }
          if (item.refund_type === 2 && (!item.refund_product.num)) {
            this.$message({
              type: 'warning',
              message: item.order_product.product_name + item.order_product.params + '售后数量不能为空'
            })
            isEmpty = true;
          }
          if (item.refund_type === 3 && (!item.order_changes.change_num || !item.order_changes.sku_id)) {
            this.$message({
              type: 'warning',
              message: item.order_product.product_name + item.order_product.params + '售后数量不能为空'
            })
            isEmpty = true;
          }
          list.push(this.transformObj(item));
        }
      })
      if (isEmpty) {
        return false
      }
      if (!list.length) {
        this.$message({
          type: 'warning',
          message: '请选择售后商品'
        })
        return
      }

      try {
        await orderRefund({
          order_id: this.orderId,
          refund_detail: list,
        })
        this.$message({
          type: 'success',
          message: '提交成功'
        })
        this.toBack();
      } catch (e) {
        console.log(e)
      }
    }
  }
